<template>
  <Dashboard
    class="options"
    title="Options"
  >
    <Button
      class="options--add-button"
      title="Add option"
      to=""
      active=true
      showAddIcon=true
      v-on:handleClick="handleModal({}, 'Add', 0)"
    />

    <Table
      recordsfoundishidden=true
      :data="options"
      :isloading="isLoading"
      v-if="selectedApplicationId"
    >
      <template v-slot:titles>
        <th>ID</th>
        <th>Label</th>
        <th>Value</th>
        <th></th>
      </template>

      <template v-slot:row>
        <tr
          @dragover="(e) => onDragOver(item, index, e)" 
          @dragend="(e) => finishDrag(item, index, e)"
          @dragstart="(e) => startDrag(item, index, e)"
          v-for="(item, index) of options"
          class="item table--content"
          :class="{
            over: (item === over.item && item !== dragFrom),
            [over.dir]: (item === over.item && item !== dragFrom)
          }"
          draggable="true"
          v-bind:key="index"
        >
          <TdId :id="item.id"/>

          <TdTitle              
            :title="item.label"
          />

          <TdTitle              
            :title="item.value"
          />

          <TdButtons>
            <RoundedButton
              title="Edit"
              v-on:handleClick="handleModal(item, 'Edit', index)"
            >
              <EditIcon/>
            </RoundedButton>

            <RoundedButton
              title=""
              danger=true
              v-on:handleClick="handleDelete(item.id, index)"
            >
              <TrashIcon/>
            </RoundedButton>
          </TdButtons>
        </tr>
      </template>
    </Table>

    <NoApplicationSelected v-else/>

    <Modal 
      closeIcon="true"
      v-on:close="handleModal"
      v-if="!modal.isHidden"
    >      
      <template v-slot:title>
        <h3>{{ modal.title }} option</h3>
      </template>

      <template v-slot:content>
        <form>
          <div class="row">
            <Input
              class="col-12"
              placeholder="Label"
              type="text"
              :value="modal.data.label"
              v-model="modal.data.label"
            />

            <Input
              class="col-12"
              placeholder="Skip to"
              type="number"
              :value="modal.data.skipto"
              v-model="modal.data.skipto"
            />

            <Input
              class="col-12"
              placeholder="Value"
              type="number"
              :value="modal.data.value"
              v-model="modal.data.value"
            />
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton()"
          />
        </form>
      </template>      
    </Modal>
  </Dashboard>
</template>

<script>
  import { API } from '../../../../../services/api.ts'
  import Dashboard from '../../../../../components/dashboard/dashboard.vue'
  import Button from '../../../../../components/buttons/button.vue'
  import RoundedButton from '../../../../../components/buttons/roundedButton.vue'
  import NoApplicationSelected from '../../../../../components/error/noApplicationSelected.vue'
  import Modal from '../../../../../components/modal/modal.vue'
  import Input from '../../../../../components/form/input.vue'
  import RadioInput from '../../../../../components/form/radio.vue'
  import ButtonForm from '../../../../../components/form/button.vue'

  import Table from '../../../../../components/table/table.vue'
  import TdTitle from '../../../../../components/table/td/title.vue'
  import TdId from '../../../../../components/table/td/id.vue'
  import TdSortOrder from '../../../../../components/table/td/sortOrder.vue'
  import TdButtons from '../../../../../components/table/td/buttons.vue'
  import TrashIcon from '../../../../../icons/trash.vue'
  import EditIcon from '../../../../../icons/edit.vue'
  import SwitchForm from '../../../../../components/form/switch.vue'

  export default {
    name: 'Options',
    components: {
      Dashboard,
      Button,
      RoundedButton,
      NoApplicationSelected,
      Modal,
      Input,
      RadioInput,
      ButtonForm,
      Table,
      TdTitle,
      TdId,
      TdSortOrder,
      TdButtons,
      TrashIcon,
      EditIcon,
      SwitchForm
    },
    data() {
      return {
        selectedApplicationId: localStorage.selectedApplicationId,
        isLoading: true,
        options: [],
        over: {},
        startLoc: 0,
        dragging: false,
        dragFrom: {},
        modal: {
          isHidden: true,
          title: '',
          index: 0,
          data: {}
        }
      }
    },
    methods: {
      startDrag(item, i, e) {
        this.startLoc = e.clientY;
        this.dragging = true;
        this.dragFrom = item;
      },
      finishDrag(item, pos) {
        this.options.splice(pos, 1)
        this.options.splice(this.over.pos, 0, item);
        this.over = {}

        for (const [index, item] of this.options.entries()) {
          item.rank = index + 1;

          API.patch(
            `index.cfm?act=questionnaireoptions.item&id=${item.id}`,
            {
              rank: `${index + 1}`
            }
          ).then(
            response => {
              console.log(response.data.data);
            }
          )
        }
      },
      onDragOver(item, pos, e) {
        const dir = (this.startLoc < e.clientY) ? 'down': 'up';
        setTimeout(() => {
          this.over = { item, pos, dir };        
        }, 10)
      },
      handleModal: function(item, title, index) {
        this.modal.title = title;

        if (title === 'Add') {
          if (this.modal.isHidden === true) {
            this.modal.isHidden = false;
            this.modal.data = {
              id: 0,
              label: '',
              rank: 0,
              skipto: '',
              value: 0
            }
          } else {
            this.modal.isHidden = true;
          }
        } else {
          if (this.modal.isHidden === true) {
            this.modal.index = index;
            
            API.get(
              `index.cfm?act=questionnaireoptions.item&id=${item.id}`
            ).then(
              response => {
                this.modal.isHidden = false;
                this.modal.data = response.data.data;
              }
            )
          } else {
            this.modal.isHidden = true;
          }
        }
      },
      handleModalButton: function() {
        if (this.modal.title === 'Add') {
          API.post(
            `index.cfm?act=questionnaireoptions.item&questionid=${this.$route.params.optionid}`,
            {
              label: this.modal.data.label,
              skipto: this.modal.data.skipto,
              value: this.modal.data.value
            }
          ).then(
            response => {
              location.reload();
            }
          )
        } else {
          API.patch(
            `index.cfm?act=questionnaireoptions.item&id=${this.modal.data.id}`,
            {
              label: this.modal.data.label,
              skipto: this.modal.data.skipto,
              value: this.modal.data.value
            }
          ).then(
            response => {
              this.options[this.modal.index].label = response.data.data.label;
              this.options[this.modal.index].skipto = response.data.data.skipto;
              this.options[this.modal.index].value = response.data.data.value;

              this.modal.isHidden = true;
            }
          )
        }
      },
      handleDelete: function(id, index) {
        if (confirm("Are you sure you want to delete this section?")) {
          API.delete(
            `index.cfm?act=questionnaireoptions.item&id=${id}`
          ).then(
            response => {
              this.options.splice(index, 1);
            }
          )
        }
      },
    },
    mounted() {
      const self = this;

      API.get(
      `index.cfm?act=questionnaireoptions.list&id=${this.$route.params.optionid}`
      ).then(
        response => {
          console.log(response.data.data);
          this.options = response.data.data;
          this.isLoading = false;
        }
      ).catch(function (error) {
        if (error.response.status === 403) {
          localStorage.removeItem('selectedApplicationName');
          localStorage.removeItem('selectedApplicationId');        
          self.selectedApplicationId = null
        }
      });
    }
  }
</script>

<style lang="scss">
  .options {
    &--add-button {
      float: right;
    }

    .table {
      float: left;
    }

    .switch {
      margin-bottom: 15px;
    }
  }
</style>
